<template>
    <div v-if='emprestimos.data' class="col-md-12 col-12">
        <card :title="title">
          <div class="table-responsive">
          <table class="table">
            <thead>
              <th class='sortable' @click="orderBy('titulo')">
                <carets-up-down title='Obra' property='titulo' :filter='filter'></carets-up-down>
              </th>
              <th class='sortable' @click="orderBy('nome')">
                <carets-up-down title='Membro' property='nome' :filter='filter'></carets-up-down>
              </th>
              <th class='sortable' @click="orderBy('devolvido')">
                <carets-up-down title='Devolvido' property='devolvido' :filter='filter'></carets-up-down>
              </th>
              <th class='sortable' @click="orderBy('renovacoes')">
                <carets-up-down title='Renovações' property='renovacoes' :filter='filter'></carets-up-down>
              </th>
              <th class='sortable' @click="orderBy('duracao')">
                <carets-up-down title='Dias' property='duracao' :filter='filter'></carets-up-down>
              </th>
              <th class='sortable' @click="orderBy('semanas_por_renovacao')" title="Ideal é menor que 3">
                <carets-up-down title='Semanas Por Renovação' property='semanas_por_renovacao' :filter='filter'></carets-up-down>
              </th>
            </thead>
            <tbody>
              <tr v-for="(emprestimo, index) in emprestimos.data.content" :key='`emprestimo-${index}`'>
                <td>
                  <div>{{emprestimo.titulo}}</div>
                  <small>{{emprestimo.subtitulo}}</small>
                </td>
                <td>{{emprestimo.nome}} {{emprestimo.sobrenome}}</td>
                <td>
                  <span class='label label-success' v-if='emprestimo.devolvido'>SIM</span>
                  <span class='label label-danger' v-else>NÂO</span>
                </td>
                <td> <span class="badge badge-pill badge-primary">{{emprestimo.renovacoes}}</span></td>
                <td>{{emprestimo.duracao}}</td>
                <td><span :class="{'badge-primary' : emprestimo.semanas_por_renovacao <= 3, 'badge-danger' : emprestimo.semanas_por_renovacao > 3}" class="badge badge-pill">{{emprestimo.semanas_por_renovacao}}</span></td>
              </tr>
            </tbody>
          </table>
          <pagination :count='emprestimos.data.count' :limit='filter.limit' :page='page' @changePage='changePage($event)'></pagination>
          </div>
          <div class="footer">
            <div class="chart-legend">
              <slot name="legend"></slot>
            </div>
            <hr>
            <div class="stats">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" :id="id" class="custom-control-input" v-model='emprestimos.children' @change='childrenChange()'>
                <label class="custom-control-label" :for="id">Incluir Livros Infantis</label>
              </div>
            </div>
          </div>
        </card>
      </div>
</template>
<script>

import { Pagination } from '@/components'
import CaretsUpDown from './CaretsUpDown'

export default {

  components: {
    Pagination,
    CaretsUpDown
  },

  props: {
    emprestimos: Object,
    title: String
  },

  data () {
    return {
      id: null,
      filter: {
        limit: 10,
        orderBy: [{ orderBy: 'duracao', direction: 'desc' }]
      },
      page: 0
    }
  },

  methods: {

    orderBy (value) {
      if (this.filter.orderBy[0].orderBy === value) {
        const direction = this.filter.orderBy[0].direction
        this.filter.orderBy = [{ orderBy: value, direction: direction === 'desc' ? 'asc' : 'desc' }]
      } else {
        this.filter.orderBy = [{ orderBy: value, direction: 'desc' }]
      }

      console.log(this.filter.orderBy[0].orderBy)
      this.childrenChange()
    },

    childrenChange () {
      this.resetPage()
      this.$emit('change', this.filter)
    },

    changePage (page) {
      this.page = page
      this.filter.offset = this.getOffset()
      this.$emit('change', this.filter)
    },

    resetPage () {
      this.page = 0
      this.filter.offset = this.getOffset()
    },

    getOffset () {
      return this.filter.limit * this.page
    }

  },

  mounted () {
    this.id = this._uid
  }

}
</script>
<style>
.sortable {
  cursor: pointer;
}
</style>

